const STORAGE_KEY = "compare_products";

export const getStoredProducts = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

export const setStoredProducts = (products) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
};

export const getStoredIds = () =>
  getStoredProducts()
    .map(({ id }) => Number.parseInt(id, 10))
    .filter(Boolean);

export const removeStoredProduct = (productId) => {
  const updatedProducts = getStoredProducts().filter(
    ({ id }) => String(id) !== String(productId),
  );

  setStoredProducts(updatedProducts);
  return updatedProducts;
};

export const clearStoredProducts = () => {
  localStorage.removeItem(STORAGE_KEY);
};